import React, { useState } from "react";
import Login from './loginComponent/login';
import Register from './registerComponent/register';

const Auth = (props) => {

    const [formType, setFormType] = useState(props.formType);
    const [toggleForm, setToggleForm] = useState(false);

    const switchForms = (formType) => {
        setFormType(formType);
        setToggleForm(true);
    }

    const goBack = () => {
        props.toggleAuth(props.formType)
        setToggleForm(false);
    }
    
    return (
        <div className={`auth-page-container ${props.toggleVisibilityAuth ? "left-menu-visible" : "left-menu-hidden"} `}>
            <div className="back-to-box" onClick={goBack}>
                <img  src="/assets/images/arrowBack.svg" alt="Back to" /></div>
            <div className="container auth">
                {(!toggleForm ? props.formType : formType) === 'login' ? <Login switchForms={switchForms} /> : <Register switchForms={switchForms} />
                }
            </div>
        </div>
    )
}
export default Auth;


// WEBPACK FOOTER //
// ./src/components/auth/auth.js